import * as actionTypes from '../../actions/actionTypes';

const appActionTypes = actionTypes.appActionTypes;

/**
 * Current page reducer: update current page
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
export function APP_currentPage(state = null, action) {
	switch (action.type) {
		case appActionTypes.UPDATE_CURRENT_PAGE:
			return action.currentPage;
		default:
			return state;
	}
}

/**
 * Locale reducer: update locale
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
export function APP_locale(state = null, action) {
	switch (action.type) {
		case appActionTypes.UPDATE_LOCALE:
			return action.locale;
		default:
			return state;
	}
}

/**
 * Network reducer: update network connectivity status
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
export function APP_network(state = null, action) {
	switch (action.type) {
		case appActionTypes.UPDATE_NETWORK_STATUS:
			return action.online === true ? 'online' : 'offline';
		default:
			return state;
	}
}

/**
 * Device type reducer: update device type
 * @param {string} state - current state
 * @param {object} action
 * @return {string} next state
 */
export function APP_deviceType(state = null, action) {
	switch (action.type) {
		case appActionTypes.UPDATE_DEVICE_TYPE:
			return action.deviceType;
		default:
			return state;
	}
}



// WEBPACK FOOTER //
// ../~/@jg/justgiving-app-login/app/reducers/reducers/appReducers.js